import React from 'react';
import styles from './infoTextBanner.module.scss';

export type infoTextBannerType = {
    startDate: Date;
    endDate: Date;
    content: string;
};

function InfoTextBanner({ startDate, endDate, content }: infoTextBannerType) {
    const now = new Date();
    if (startDate <= now && now <= endDate) {
        return <p className={styles.description}>{content}</p>;
    }
    return <></>;
}

export default InfoTextBanner;
